//인증번호 발송 이벤트
const otp_request_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'complete_sms' })
}

//가입 완료 이벤트
const join_complete_dataLayer = (pNumber) => {
  window.dataLayer = window.dataLayer || []
  window.phone_number = '+82' + pNumber.slice(1)
  window.dataLayer.push({ event: 'complete_signup' })
}

//기가입자 이벤트
const already_signup_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'already_signup' })
}

//30일 재가입
const d30_resignup_dataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: '30d_resignup' })
}

export {
  otp_request_dataLayer,
  join_complete_dataLayer,
  already_signup_dataLayer,
  d30_resignup_dataLayer,
}

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// 신규 가입창 작업시에 dataLayer 삽입
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
